<button class="text-nowrap" :disabled="disabled" :class="classNameLocal" v-translate="optionsTranslate_TableCellMixin" @click="callbackLocal"></button>